import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-orto-layout',
    templateUrl: './orto-layout.component.html',
    styleUrls: ['./orto-layout.component.scss'],
    standalone: false
})
export class OrtoLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
